import { ENDPOINTS } from '@/lib/consts.js'
import DeviceIdentity from './device-identity.js'

export default class IOSIdentity extends DeviceIdentity {
  registerToken ({ businessId, token }) {
    return this.apiCall({
      method: 'PUT',
      url: ENDPOINTS.IOS_TOKEN,
      urlParams: {
        businessId,
        token,
      },
    }).then(() => {
      this.logger.log('Token registered', { businessId, token })
    }).catch(error => {
      this.logger.error(error)
    })
  }

  clearToken ({ businessId, token }) {
    return this.apiCall({
      method: 'DELETE',
      url: ENDPOINTS.IOS_TOKEN,
      urlParams: {
        businessId,
        token,
      },
    }).then(() => {
      this.logger.log('Token cleared', { businessId, token })
    }).catch(error => {
      this.logger.error(error)
    })
  }
}
